export default __webpack_public_path__ + "static/media/Manisha.7f950c39.jpg";